<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <logo />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <notification-dropdown
        v-if="$store.state.cuenta.session.token"
        v-b-tooltip.hover.bottom="'Notificaciones de usuario'"
      />
      <dark-Toggler
        v-b-tooltip.hover.bottom="`Modo ${isDark ? 'normal' : 'nocturno'}`"
        class="d-none d-lg-block"
      />
      <user-dropdown
        v-if="$store.state.cuenta.session.token"
        v-b-tooltip.hover.bottom="'Información del usuario'"
      />
      <login-register
        v-else
        v-b-tooltip.hover.bottom="'Iniciar sesión'"
      />
      <rol-home
        v-if="$store.state.cuenta.session.token"
        v-b-tooltip.hover.bottom="'Pantalla inicial de usuario'"
      />
      <change-rol
        v-if="$store.state.cuenta.session.token && rolesDisponibles.length > 1"
        v-b-tooltip.hover.bottom="'Cambio de rol'"
      />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, VBTooltip } from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Logo from '@core/layouts/components/Logo.vue'
import NotificationDropdown from '@core/layouts/components/app-navbar/components/NotificationDropdown.vue'
import UserDropdown from '@core/layouts/components/app-navbar/components/UserDropdown.vue'
import LoginRegister from '@/@core/layouts/components/app-navbar/components/LoginButton.vue'
import ChangeRol from '@core/layouts/components/app-navbar/components/ChangeRol.vue'
import RolHome from '@core/layouts/components/app-navbar/components/RolHome.vue'
import {
  computed,
} from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import store from '@/store/index'

export default {
  components: {
    BLink,
    BNavbarNav,
    Logo,

    // Navbar Components
    DarkToggler,
    UserDropdown,
    NotificationDropdown,
    LoginRegister,
    ChangeRol,
    RolHome,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')

    // Computed propieties
    const rolesDisponibles = computed(() => store.state.cuenta.rolesDisponibles)

    return {
      rolesDisponibles,
      isDark,
    }
  },
}
</script>
